import { useRef, useEffect } from 'react'
import { useFullscreen, useToggle } from 'react-use'

const useFullscreen_ = ({ node, onToggle }) => {
  const isMounted = useRef(false)
  const [show, toggleFullscreen] = useToggle(false)
  const isFullscreen = useFullscreen({ current: node }, show, {
    onClose: () => toggleFullscreen(false),
  })

  useEffect(() => {
    if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen()
    }
    if (isMounted.current) {
      onToggle && onToggle()
    }
    isMounted.current = true
  }, [show])

  return [isFullscreen, toggleFullscreen]
}

export default useFullscreen_
